// Firebase configuration for CIBS Dance Academy
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyDOeL4_JpyNfzaKCFfXAI9RUWY5ahaemGY",
  authDomain: "cibs-dance-academy.firebaseapp.com",
  projectId: "cibs-dance-academy",
  storageBucket: "cibs-dance-academy.firebasestorage.app",
  messagingSenderId: "243235488642",
  appId: "1:243235488642:web:af1788a89f7ff43232859b"
};

// VAPID key for web push
const VAPID_KEY = "BPlYR1Fe_Cr5oNmZakRcHVYwJ7CrMjjcArYA9bggBcL4GZUCwzxmnMKVBBjighJMIkWPxOH1gH0npMf1zudFobo";

// Initialize Firebase
let app;
let messaging;

try {
  app = initializeApp(firebaseConfig);
  // Check if browser supports notifications
  if ('Notification' in window && 'serviceWorker' in navigator) {
    messaging = getMessaging(app);
  }
} catch (error) {
  console.error('Firebase initialization error:', error);
}

// Request notification permission and get FCM token
export const requestNotificationPermission = async () => {
  try {
    if (!('Notification' in window)) {
      console.log('This browser does not support notifications');
      return null;
    }

    const permission = await Notification.requestPermission();
    
    if (permission === 'granted') {
      // Register service worker if not already registered
      const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
      
      // Get FCM token
      const token = await getToken(messaging, {
        vapidKey: VAPID_KEY,
        serviceWorkerRegistration: registration
      });
      
      console.log('FCM Token:', token);
      return token;
    } else {
      console.log('Notification permission denied');
      return null;
    }
  } catch (error) {
    console.error('Error requesting notification permission:', error);
    return null;
  }
};

// Listen for foreground messages
export const onForegroundMessage = (callback) => {
  if (!messaging) return () => {};
  
  return onMessage(messaging, (payload) => {
    console.log('Foreground message received:', payload);
    callback(payload);
  });
};

// Check if notifications are supported
export const isNotificationSupported = () => {
  return 'Notification' in window && 'serviceWorker' in navigator;
};

// Get current notification permission status
export const getNotificationPermissionStatus = () => {
  if (!('Notification' in window)) return 'unsupported';
  return Notification.permission;
};

export { app, messaging };
